import { Action, initialState, State } from '../store/store';

//
export const setRootBlock = (state: State = initialState, { data }: Action): State => {
  const nextState = {
    ...state,
    rootBlockId: data as any,
  };
  return nextState;
};
